import { Link } from 'react-router-dom';
import { articles, hotTags, categories } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function LatestSection() {
  const latestArticles = articles.slice(0, 8);
  const hotArticles = articles.filter(a => a.isHot).slice(0, 5);
  const sidebarArticles = articles.slice(4, 9);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-8">
          <div className="flex-1">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100">
                  <i className="ri-newspaper-line text-primary-600 text-lg"></i>
                </div>
                <h2 className="text-lg md:text-xl font-heading text-foreground-900">51cg最新吃瓜热闻</h2>
              </div>
              <Link
                to="/category/all"
                className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap"
              >
                更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="space-y-4">
              {latestArticles.map((article) => (
                <ArticleCard key={article.id} article={article} variant="horizontal" />
              ))}
            </div>
          </div>

          <aside className="w-full lg:w-80 flex-shrink-0">
            <div className="lg:sticky lg:top-24 space-y-6">
              <div className="bg-background-50 rounded-lg p-5 border border-background-200/60">
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-accent-100">
                    <i className="ri-hashtag text-accent-600"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900">51cg今日热点</h3>
                </div>
                <div className="flex flex-wrap gap-2">
                  {hotTags.map((tag) => (
                    <span
                      key={tag}
                      className="px-3 py-1.5 text-xs rounded-full bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      #{tag}
                    </span>
                  ))}
                </div>
              </div>

              <div className="bg-background-50 rounded-lg p-5 border border-background-200/60">
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-primary-100">
                    <i className="ri-flashlight-line text-primary-600"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900">51cg吃瓜速递</h3>
                </div>
                <div className="space-y-4">
                  {sidebarArticles.map((article) => (
                    <ArticleCard key={article.id} article={article} variant="compact" />
                  ))}
                </div>
              </div>

              <div className="bg-background-50 rounded-lg p-5 border border-background-200/60">
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-secondary-100">
                    <i className="ri-folder-open-line text-secondary-600"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900">分类导航</h3>
                </div>
                <div className="space-y-2">
                  {categories.filter(c => c.slug !== 'all').map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center justify-between px-3 py-2.5 rounded-lg hover:bg-background-100 transition-colors group"
                    >
                      <span className="text-sm text-foreground-700 group-hover:text-primary-500 transition-colors">{cat.name}</span>
                      <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}